import $ from 'jquery';
import _ from 'jquery-match-height';

theme.Collection = (function () {
  $('.collection-grid-item__match-height').matchHeight();
})();
